import script from "./AppFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFooter.vue?vue&type=script&setup=true&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=5abee73c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5abee73c"]])

export default __exports__